import { UrlObject } from 'url'
import { useRouter } from 'next/router'
import { useEffect } from 'react'

interface RedirectProps {
  to: UrlObject | string
  type?: 'push' | 'replace'
}

export const Redirect: React.FC<RedirectProps> = ({ to, type = 'push' }) => {
  const pushOrReplace = useRouter()[type]

  useEffect(() => {
    void pushOrReplace(to)
  }, [pushOrReplace, to])

  return null
}
